import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const changeDocDoneDate = async ({ docId, doneDate }) => {
  return await request.put(
    `/Docs/update_done_date?doneDate=${doneDate}&docId=${docId}`,
    null,
    'При изменении даты назначения документа произошла ошибка',
    'Error'
  );
};

const useUpdateDoneDate = () => {
  const mutation = useMutation(changeDocDoneDate, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

  return {
    isLoadingDocDoneDate: mutation.isLoading,
    changeDocDoneDate: mutation.mutateAsync,
  };
};

export default useUpdateDoneDate;
